const lootOptions = {
    GOOD: 'good',
    BAD_TREE_LEFT: 'bad-tree-left',
    BAD_TREE_RIGHT: 'bad-tree-right',
    BAD_ROADBLOCK: 'bad-roadblock',
    BAD_HOLE: 'bad-hole',
    BAD_POLICE: 'bad-police',
    BAD_HOTDOG: 'bad-hotdog',
    BAD_SEWERAGE: 'bad-sewerage',
    BAD_LOG: 'bad-log',
    PROTECTION_1: 'protection-1',
    PROTECTION_2: 'protection-2',
    PROTECTION_3: 'protection-3'
};

export const lootOptionsArray = Array.from(Object.keys(lootOptions));

export const lootOptionsWeights = [
    16, // good
    2, // bad-tree-left
    2, // bad-tree-right
    2, // bad-roadblock
    2, // bad-hole
    2, // bad-police
    2, // bad-hotdog
    2, // bad-sewerage
    2, // bad-log
    2, // protection-1
    2, // protection-1
    2 // protection-3
];

export default lootOptions;
